/**
 * Converts an RGB color string to an RGBA color string with a specified opacity.
 *
 * @param {string | undefined} rgb - The RGB color string to convert.
 * @param {string} opacity - The opacity value to apply to the RGBA color.
 * @returns {string} The RGBA color string with the specified opacity.
 */
export const rgbToRgba = (rgb: string | undefined, opacity: string) => {
  // Check if the input rgb is a string
  if (typeof rgb === "string") {
    // Store the input color string
    const colour = rgb;

    // Replace 'rgb' with 'rgba' in the color string
    let new_col = colour.replace(/rgb/i, "rgba");

    // Append the opacity value to the color string
    new_col = new_col.replace(/\)/i, `,${opacity})`);

    // Return the new RGBA color string
    return new_col;
  }

  // Return a transparent color if the input rgb is undefined
  return "rgba(0,0,0,0)";
};
